/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const AlertTriangleFilledIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M23.4485164,22.75425 L12.4485164,0.75425 C12.2785164,0.41525 11.7225164,0.41525 11.5535164,0.75425 L0.553516416,22.75425 C0.387516416,23.08425 0.627516416,23.47825 1.00051642,23.47825 L23.0005164,23.47825 C23.3745164,23.47825 23.6145164,23.08425 23.4485164,22.75425 Z M11.5005164,8.63025 C11.5015164,8.35425 11.7255164,8.13025 12.0015164,8.13025 C12.2765164,8.13025 12.5015164,8.35425 12.5005164,8.63025 L12.5005164,16.28225 C12.5015164,16.55725 12.2765164,16.78225 12.0015164,16.78225 C11.7255164,16.78225 11.5015164,16.55725 11.5005164,16.28225 L11.5005164,8.63025 Z M12.0015164,20.58625 C11.4725164,20.58625 11.0445164,20.15825 11.0445164,19.63025 C11.0445164,19.10325 11.4725164,18.67325 12.0015164,18.67325 C12.5285164,18.67325 12.9575164,19.10325 12.9575164,19.63025 C12.9575164,20.15925 12.5285164,20.58625 12.0015164,20.58625 Z" />
    </g>
  </svg>
);

export default AlertTriangleFilledIcon;
